(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-notices"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eco-notices')) {
    class EcoNotices extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-notice]'));
        if (!this.items.length) return;
        this.index = 0;
        this.showTimer = setTimeout(() => this.#show(0), 700);
        if (this.items.length > 1) {
          const interval = Math.max(2500, Number(this.dataset.interval) || 5000);
          this.timer = setInterval(() => {
            if (document.hidden) return;
            this.#show((this.index + 1) % this.items.length);
          }, interval);
        }
      }

      disconnectedCallback() {
        clearTimeout(this.showTimer);
        clearInterval(this.timer);
      }

      #show(next) {
        this.items[this.index]?.classList.remove('is-active');
        this.index = next;
        this.items[next].classList.add('is-active');
      }
    }

    customElements.define('eco-notices', EcoNotices);
  }
  } catch(e) { console.error(e); }
})();

})();
